module.exports = __webpack_public_path__ + "static/img/ecpay.9cc94e35.png";